var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H40C44.4183 0 48 3.58172 48 8V40C48 44.4183 44.4183 48 40 48H8C3.58172 48 0 44.4183 0 40V8Z",
    fill: "#FFAD00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3335 26.6666C13.0812 26.6674 12.8338 26.5967 12.6201 26.4625C12.4064 26.3284 12.2351 26.1364 12.1262 25.9088C12.0173 25.6812 11.9752 25.4273 12.0048 25.1768C12.0344 24.9262 12.1345 24.6892 12.2935 24.4932L25.4935 10.8932C25.5925 10.7789 25.7274 10.7017 25.8761 10.6742C26.0248 10.6467 26.1785 10.6706 26.3118 10.7419C26.4451 10.8132 26.5503 10.9278 26.6099 11.0667C26.6696 11.2057 26.6803 11.3608 26.6402 11.5066L24.0802 19.5332C24.0047 19.7353 23.9793 19.9526 24.0063 20.1666C24.0332 20.3806 24.1117 20.5848 24.2349 20.7618C24.3582 20.9388 24.5225 21.0832 24.7139 21.1828C24.9052 21.2823 25.1178 21.3339 25.3335 21.3332H34.6668C34.9191 21.3324 35.1665 21.4031 35.3802 21.5373C35.5939 21.6714 35.7652 21.8634 35.8741 22.091C35.983 22.3186 36.0251 22.5724 35.9955 22.823C35.9659 23.0736 35.8658 23.3106 35.7068 23.5066L22.5068 37.1066C22.4078 37.2208 22.2729 37.2981 22.1242 37.3256C21.9755 37.3531 21.8219 37.3292 21.6885 37.2579C21.5552 37.1866 21.45 37.072 21.3904 36.9331C21.3307 36.7941 21.32 36.639 21.3602 36.4932L23.9202 28.4666C23.9956 28.2645 24.021 28.0472 23.994 27.8332C23.9671 27.6192 23.8886 27.415 23.7654 27.238C23.6421 27.061 23.4778 26.9165 23.2865 26.817C23.0951 26.7175 22.8825 26.6659 22.6668 26.6666H13.3335Z",
    stroke: "#004AAD",
    strokeWidth: 2.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZap);
export default __webpack_public_path__ + "static/media/zap.b82bd99a40233eeebe79841e3c5ecd60.svg";
export { ForwardRef as ReactComponent };